import produce from 'immer';
import { PAYMENT_FULFILLED } from '../constants/actions/paymentActions';
import { RESET_TO_INITIAL_VALUES } from '../constants/actions/registerShipmentFormActions';
import {
	ADD_CUSTOMS_INFORMATION_FULFILLED,
	DELETE_SHIPMENT,
	DELETE_SHIPMENT_FAILED,
	DELETE_SHIPMENT_FULFILLED,
	FETCH_LOCKER_CODE,
	FETCH_LOCKER_CODE_FAILED,
	FETCH_LOCKER_CODE_FULFILLED,
	FETCH_SHIPMENT,
	FETCH_SHIPMENT_DETAILS,
	FETCH_SHIPMENT_DETAILS_FAILED,
	FETCH_SHIPMENT_DETAILS_FULFILLED,
	FETCH_SHIPMENT_DOCUMENTS,
	FETCH_SHIPMENT_DOCUMENTS_FAILED,
	FETCH_SHIPMENT_DOCUMENTS_FULFILLED,
	FETCH_SHIPMENT_FAILED,
	FETCH_SHIPMENT_FEES,
	FETCH_SHIPMENT_FEES_FAILED,
	FETCH_SHIPMENT_FEES_FULFILLED,
	FETCH_SHIPMENT_FULFILLED,
	INBOUND_ACTIVE_SHIPMENTS_FAILED,
	INBOUND_ACTIVE_SHIPMENTS_FULFILLED,
	INBOUND_ACTIVE_SHIPMENTS_LOADING,
	INBOUND_DELIVERED_SHIPMENTS_FAILED,
	INBOUND_DELIVERED_SHIPMENTS_FULFILLED,
	INBOUND_DELIVERED_SHIPMENTS_LOADING,
	OUTBOUND_ACTIVE_SHIPMENTS_FAILED,
	OUTBOUND_ACTIVE_SHIPMENTS_FULFILLED,
	OUTBOUND_ACTIVE_SHIPMENTS_LOADING,
	OUTBOUND_DELIVERED_SHIPMENTS_FAILED,
	OUTBOUND_DELIVERED_SHIPMENTS_FULFILLED,
	OUTBOUND_DELIVERED_SHIPMENTS_LOADING,
} from '../constants/actions/shipmentsActions';
import { LOGOUT_FULFILLED } from '../constants/actions/userProfileActions';
import IShipmentsReducer from '../interfaces/reducers/shipmentsReducer';

const initialValues: IShipmentsReducer = {
	shipments: null,
	shipmentsInbound: {
		results: {},
		totalPageCount: 0,
		currentPage: 0,
		pageSize: 0,
		totalCount: 0,
		loading: true,
		error: false,
		fetched: [],
	},
	shipmentsInboundDelivered: {
		results: {},
		totalPageCount: 0,
		currentPage: 0,
		pageSize: 0,
		totalCount: 0,
		loading: true,
		error: false,
		fetched: [],
	},
	shipmentsOutbound: {
		results: {},
		totalPageCount: 0,
		currentPage: 0,
		pageSize: 0,
		totalCount: 0,
		loading: true,
		error: false,
		fetched: [],
	},
	shipmentsOutboundDelivered: {
		results: {},
		totalPageCount: 0,
		currentPage: 0,
		pageSize: 0,
		totalCount: 0,
		loading: true,
		error: false,
		fetched: [],
	},
	shipmentDetails: {},
	shipmentDocuments: {},
	shipmentFeesLoading: false,
	shipmentFeesError: false,
	shipmentFees: {},
	shipmentLoading: false,
	shipmentError: false,
	shipment: null,
	lockerCode: {},
};

const shipmentsReducer = produce((draft: IShipmentsReducer, action) => {
	switch (action.type) {
		case INBOUND_ACTIVE_SHIPMENTS_LOADING: {
			draft.shipmentsInbound.loading = true;
			draft.shipmentsInbound.error = false;
			draft.shipmentsInbound.fetched[action.payload.page] = Date.now();
			break;
		}
		case INBOUND_ACTIVE_SHIPMENTS_FAILED: {
			draft.shipmentsInbound.loading = false;
			draft.shipmentsInbound.error = true;
			draft.shipmentsInbound.results[action.payload.page] = [];
			break;
		}
		case INBOUND_ACTIVE_SHIPMENTS_FULFILLED: {
			draft.shipmentsInbound.currentPage = action.payload.currentPage;
			draft.shipmentsInbound.pageSize = action.payload.pageSize;
			draft.shipmentsInbound.results[action.payload.currentPage] = action.payload.results;
			draft.shipmentsInbound.totalCount = action.payload.totalCount;
			draft.shipmentsInbound.totalPageCount = action.payload.totalPageCount;
			draft.shipmentsInbound.loading = false;
			draft.shipmentsInbound.error = false;
			break;
		}
		case OUTBOUND_ACTIVE_SHIPMENTS_LOADING: {
			draft.shipmentsOutbound.loading = true;
			draft.shipmentsOutbound.error = false;
			draft.shipmentsOutbound.fetched[action.payload.page] = Date.now();
			break;
		}
		case OUTBOUND_ACTIVE_SHIPMENTS_FAILED: {
			draft.shipmentsOutbound.loading = false;
			draft.shipmentsOutbound.error = true;
			draft.shipmentsOutbound.results[action.payload.page] = [];
			break;
		}
		case OUTBOUND_ACTIVE_SHIPMENTS_FULFILLED: {
			draft.shipmentsOutbound.currentPage = action.payload.currentPage;
			draft.shipmentsOutbound.pageSize = action.payload.pageSize;
			draft.shipmentsOutbound.results[action.payload.currentPage] = action.payload.results;
			draft.shipmentsOutbound.totalCount = action.payload.totalCount;
			draft.shipmentsOutbound.totalPageCount = action.payload.totalPageCount;
			draft.shipmentsOutbound.loading = false;
			draft.shipmentsOutbound.error = false;
			break;
		}
		case OUTBOUND_DELIVERED_SHIPMENTS_LOADING: {
			draft.shipmentsOutboundDelivered.loading = true;
			draft.shipmentsOutboundDelivered.error = false;
			draft.shipmentsOutboundDelivered.fetched[action.payload.page] = Date.now();
			break;
		}
		case OUTBOUND_DELIVERED_SHIPMENTS_FAILED: {
			draft.shipmentsOutboundDelivered.loading = false;
			draft.shipmentsOutboundDelivered.error = true;
			draft.shipmentsOutboundDelivered.results[action.payload.page] = [];
			break;
		}
		case OUTBOUND_DELIVERED_SHIPMENTS_FULFILLED: {
			draft.shipmentsOutboundDelivered.currentPage = action.payload.currentPage;
			draft.shipmentsOutboundDelivered.pageSize = action.payload.pageSize;
			draft.shipmentsOutboundDelivered.results[action.payload.currentPage] = action.payload.results;
			draft.shipmentsOutboundDelivered.totalCount = action.payload.totalCount;
			draft.shipmentsOutboundDelivered.totalPageCount = action.payload.totalPageCount;
			draft.shipmentsOutboundDelivered.loading = false;
			draft.shipmentsOutboundDelivered.error = false;
			break;
		}
		case INBOUND_DELIVERED_SHIPMENTS_LOADING: {
			draft.shipmentsInboundDelivered.loading = true;
			draft.shipmentsInboundDelivered.error = false;
			draft.shipmentsInboundDelivered.fetched[action.payload.page] = Date.now();
			break;
		}
		case INBOUND_DELIVERED_SHIPMENTS_FAILED: {
			draft.shipmentsInboundDelivered.loading = false;
			draft.shipmentsInboundDelivered.error = true;
			draft.shipmentsInboundDelivered.results[action.payload.page] = [];
			break;
		}
		case INBOUND_DELIVERED_SHIPMENTS_FULFILLED: {
			draft.shipmentsInboundDelivered.currentPage = action.payload.currentPage;
			draft.shipmentsInboundDelivered.pageSize = action.payload.pageSize;
			draft.shipmentsInboundDelivered.results[action.payload.currentPage] = action.payload.results;
			draft.shipmentsInboundDelivered.totalCount = action.payload.totalCount;
			draft.shipmentsInboundDelivered.totalPageCount = action.payload.totalPageCount;
			draft.shipmentsInboundDelivered.loading = false;
			draft.shipmentsInboundDelivered.error = false;
			break;
		}
		case FETCH_SHIPMENT_DETAILS: {
			const shipmentDetail = {
				loading: true,
				error: false,
				trackingEvents: null,
				documents: null,
				customsInfo: null,
			};
			draft.shipmentDetails[action.payload.shipmentId] = shipmentDetail;
			draft.shipmentDocuments[action.payload.shipmentId] = {
				loading: true,
				error: false,
				documents: null,
			};
			break;
		}
		case FETCH_SHIPMENT_DETAILS_FULFILLED: {
			const shipmentDetails = action.payload.shipmentDetails;
			draft.shipmentDetails[action.payload.shipmentId].loading = false;
			draft.shipmentDetails[action.payload.shipmentId].error = false;
			draft.shipmentDetails[action.payload.shipmentId].trackingEvents = shipmentDetails.trackingEvents;
			draft.shipmentDetails[action.payload.shipmentId].documents = shipmentDetails.documents;
			draft.shipmentDetails[action.payload.shipmentId].customsInfo = shipmentDetails.customsInfo;
			draft.shipmentDocuments[action.payload.shipmentId].loading = false;
			draft.shipmentDocuments[action.payload.shipmentId].error = false;
			draft.shipmentDocuments[action.payload.shipmentId].documents = shipmentDetails.documents;
			break;
		}
		case FETCH_SHIPMENT_DETAILS_FAILED: {
			draft.shipmentDetails[action.payload.shipmentId].loading = false;
			draft.shipmentDetails[action.payload.shipmentId].error = true;
			draft.shipmentDocuments[action.payload.shipmentId].loading = false;
			draft.shipmentDocuments[action.payload.shipmentId].error = true;
			break;
		}
		case FETCH_SHIPMENT_DOCUMENTS: {
			const shipmentDocument = {
				loading: true,
				error: false,
				documents: null,
			};
			draft.shipmentDocuments[action.payload.shipmentId] = shipmentDocument;
			break;
		}
		case FETCH_SHIPMENT_DOCUMENTS_FULFILLED: {
			draft.shipmentDocuments[action.payload.shipmentId].loading = false;
			draft.shipmentDocuments[action.payload.shipmentId].error = false;
			draft.shipmentDocuments[action.payload.shipmentId].documents = action.payload.documents;
			break;
		}
		case FETCH_SHIPMENT_DOCUMENTS_FAILED: {
			draft.shipmentDocuments[action.payload.shipmentId].loading = false;
			draft.shipmentDocuments[action.payload.shipmentId].error = true;
			break;
		}
		case FETCH_SHIPMENT_FEES: {
			draft.shipmentFeesLoading = true;
			draft.shipmentFeesError = false;
			break;
		}
		case FETCH_SHIPMENT_FEES_FULFILLED: {
			draft.shipmentFeesLoading = false;
			draft.shipmentFeesError = false;
			draft.shipmentFees[action.payload.shipmentId] = action.payload.fees;
			break;
		}
		case FETCH_SHIPMENT_FEES_FAILED: {
			draft.shipmentFeesLoading = false;
			draft.shipmentFeesError = true;
			break;
		}
		case FETCH_SHIPMENT: {
			draft.shipmentLoading = true;
			draft.shipmentError = false;
			break;
		}
		case FETCH_SHIPMENT_FULFILLED: {
			draft.shipmentLoading = false;
			draft.shipmentError = false;
			draft.shipment = action.payload;
			break;
		}
		case FETCH_SHIPMENT_FAILED: {
			draft.shipmentLoading = false;
			draft.shipmentError = true;
			break;
		}
		case FETCH_LOCKER_CODE: {
			const lockerCode = {
				loading: true,
				error: false,
				code: null,
			};
			draft.lockerCode[action.payload.shipmentId] = lockerCode;
			break;
		}
		case FETCH_LOCKER_CODE_FULFILLED: {
			draft.lockerCode[action.payload.shipmentId].loading = false;
			draft.lockerCode[action.payload.shipmentId].error = false;
			draft.lockerCode[action.payload.shipmentId].code = action.payload.shipmentParcelLockerCode;
			break;
		}
		case FETCH_LOCKER_CODE_FAILED: {
			draft.lockerCode[action.payload.shipmentId].loading = false;
			draft.lockerCode[action.payload.shipmentId].error = true;
			break;
		}
		case DELETE_SHIPMENT_FULFILLED: {
			break;
		}
		case DELETE_SHIPMENT_FAILED: {
			break;
		}
		case DELETE_SHIPMENT: {
			break;
		}
		case ADD_CUSTOMS_INFORMATION_FULFILLED: {
			draft.shipmentsInbound.results[action.payload.currentPage][
				draft.shipmentsInbound.results[action.payload.currentPage].findIndex(
					shipment => shipment.id === action.payload.shipmentId
				)
			].isMissingDocuments = false;
			break;
		}
		case PAYMENT_FULFILLED: {
			draft.shipmentsInbound.results[action.payload.currentPage][action.payload.shipmentIndex].isPayable = false;
			break;
		}
		case RESET_TO_INITIAL_VALUES: {
			draft.shipmentsOutbound = initialValues.shipmentsOutbound;
			break;
		}
		case LOGOUT_FULFILLED: {
			return initialValues;
		}
		default:
			break;
	}
}, initialValues);

export default shipmentsReducer;
